import { useEffect } from 'react';

export default function LightboxModal({ images, activeIndex, onClose, onNext, onPrev }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNext();
      if (e.key === 'ArrowLeft') onPrev();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose, onNext, onPrev]);

  if (activeIndex === null || !images || images.length === 0) return null;

  const currentImage = images[activeIndex];

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Billedvisning"
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6 select-none animate-in fade-in duration-150"
      onClick={onClose}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
        aria-label="Luk visning"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          className="absolute left-4 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left" aria-hidden="true" />
        </button>
      )}

      {/* Main Image Container */}
      <div
        className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={currentImage}
          alt={`Galleri billede ${activeIndex + 1} af ${images.length}`}
          className="max-w-full max-h-[80vh] object-contain shadow-2xl"
        />
        <div className="mt-3 text-white/80 text-sm font-medium tracking-wide">
          Billede {activeIndex + 1} af {images.length}
        </div>
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          className="absolute right-4 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
